import type { FC, PropsWithChildren } from 'react'

import styled from '@emotion/styled'

import Image from '@segment/matcha/components/Image'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

interface TrendSectionProps {
  order: string
  heading: string
  caption: string
  pngSrc2x: string
  webpSrc: string
  webpSrc2x: string
}

const TrendSection: FC<PropsWithChildren<TrendSectionProps>> = ({
  order,
  heading,
  caption,
  pngSrc2x,
  webpSrc,
  webpSrc2x,
}) => {
  return (
    <StyledSectionBase variant="2Col">
      <StyledSectionCopy>
        <CopyTextBase>
          <UppercaseCopyTextOverline>Trend {order}</UppercaseCopyTextOverline>
          <CopyText.Heading>{heading}</CopyText.Heading>
        </CopyTextBase>
      </StyledSectionCopy>
      <StyledSectionContents>
        <picture>
          <source type="image/webp" srcSet={`${webpSrc}, ${webpSrc2x} 2x`} />
          <Image width="640" height="280" src={pngSrc2x} alt={caption} loading="lazy" />
        </picture>
      </StyledSectionContents>
    </StyledSectionBase>
  )
}

const StyledSectionBase = styled(SectionBase)`
  ${Section.Wrapper} {
    justify-content: unset;
    margin: 0;
    padding: 40px 0;
    row-gap: 24px;

    ${({ theme }) => theme.breakpoints.up(`sm`)} {
      row-gap: 40px;
    }
  }
`

const StyledSectionCopy = styled(Section.Copy)`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
`

const StyledSectionContents = styled(Section.Contents)`
  justify-items: start;
`

const UppercaseCopyTextOverline = styled(CopyText.Overline)`
  text-transform: uppercase;
`

export default TrendSection
